(function() {
    
    let lastScrollTop = 0;
    function getMobileOperatingSystem() {
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  
      // Windows Phone must come first because its UA also contains "Android"
      if (/windows phone/i.test(userAgent)) {
          return "Windows Phone";
      }
  
      if (/android/i.test(userAgent)) {
          return "Android";
      }
  
      // iOS detection from: http://stackoverflow.com/a/9039885/177710
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
          return "iOS";
      }
  
      return "unknown";
  }

  let device = getMobileOperatingSystem()

    window.addEventListener("scroll", function(){ // or window.addEventListener("scroll"....
      var st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
      if (st > lastScrollTop){
        lastScrollTop = st
        device === "iOS" ? document.getElementById('full-cart-dialog').style.height = '100vh' : document.getElementById('full-cart-dialog').style.height = '-webkit-fill-available'
      } else {
        lastScrollTop = st
        document.getElementById('full-cart-dialog').style.height = '-webkit-fill-available'
      }
   }, false);

    //  document.querySelector('#cartTotal').setAttribute('href', '');
    //  for (let el of document.querySelectorAll('.js-cartToggle-close')) {
    //    el.addEventListener('click', () => {
    //     document.querySelector('body').classList.remove('cart--is-visible')
    //     document.querySelector('#Cart').classList.remove('open')
    //     document.querySelector('#Cart').classList.add('close')
    //    })
    //   }

    //  document.querySelector('#cartTotal').addEventListener('click', (e) => {
    //   e.preventDefault()
    //   document.querySelector('#Cart').classList.remove('close')
    //   document.querySelector('#Cart').classList.add('open')
    //   document.querySelector('body').classList.add('cart--is-visible')
    //  })
 })()

 const isCorrectScrews = (cart) => {
  const expectedScrews = {};
  const actualScrews = {};

  for (let item of cart.items) {
    let screwV = '';
    let qty = 0;
    if (item.properties.map && item.properties.type !== "Screws" && item.properties.type !== "Hidden") {
      screwV = item.properties.map.split(':')[1];
      qty = parseInt(item.properties.Screws.split(' x ')[1]) * item.quantity;
      expectedScrews[screwV] = (expectedScrews[screwV]) ? expectedScrews[screwV] + qty : qty
    }
    if (item.properties.type === "Screws" || item.properties.type === "Hidden") {
      screwV = item.id;
      qty = item.quantity;
      actualScrews[screwV] = (actualScrews[screwV]) ? actualScrews[screwV] + qty : qty
    }
  }

  let pass = true;
  for (screwId of Object.keys(expectedScrews)) {
    if (actualScrews[screwId] !== expectedScrews[screwId]) {
      pass = false
      break
    }
  }
  return pass
 }

 const checkScrews = async () => {

  document.querySelector('body').classList.add('checking-out');

  let get = await fetch(`${window.Shopify.routes.root}cart.js`);
  let cart = await get.json();

  if (isCorrectScrews(cart)) {
    await fetch(`${window.Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          'Screw Check': 'Passed'
        }
      })
    });
    document.querySelector('.cart-form').submit()
    return
  }
  let toRemove = {}

  for (let item of cart.items.filter(i => i.properties.type === "Screws" || i.properties.type === "Hidden")) {
    toRemove[item.key] = 0
  }

  if (Object.keys(toRemove).length) {
    const update = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        updates: toRemove,
        attributes: {
          'Screw Check': 'Failed => Fixed'
        }
      })
    });
    cart = await update.json()
  }

  let toAdd = []

  for (let item of cart.items.filter(i => i.properties.map && i.properties.type !== "Screws" && i.properties.type !== "Hidden")) {
    let screwV = item.properties.map.split(':')[1];
    let qty = parseInt(item.properties.Screws.split(' x ')[1]) * item.quantity;

    if (toAdd.find(screw => screw.id == screwV)) {
      toAdd.find(screw => screw.id == screwV).quantity += qty
    } else {
      toAdd.push({
        id: screwV,
        quantity: qty,
        properties: {
          type: "Screws"
        }
      })
    }
  }
  
  const add = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      items: toAdd
    })
  });

  const added = await add.json()

  get = await fetch(`${window.Shopify.routes.root}cart.js`);
  cart = await get.json();
  
  Cart.buildCart( cart )
  document.querySelector('.cart-form').submit()
}

for (let el of document.querySelectorAll('#custom_checkout_link')) el.addEventListener('click', () => { ga4Tracking.checkoutInitiated(); checkScrews(); })
